import { render } from "./FigureBoard.vue?vue&type=template&id=30b42d3b"
import script from "./FigureBoard.vue?vue&type=script&lang=js"
export * from "./FigureBoard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__